import { Component, inject } from '@angular/core';
import { ButtonComponent, ButtonVariant } from '../../common/components/core/button/button.component';
import { MyZpaxService } from 'src/app/services/myzpax.service';
import { MarketingConstants } from './marketing.constants';

@Component({
  selector: 'app-marketing',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent  {
  private _myzpaxService = inject(MyZpaxService)
  buttonVariant = ButtonVariant
  constants = MarketingConstants

  learnMore() {
    this._myzpaxService.openContactUs();
  }
}
